import API_URL from "../config/axios_defaults";
import axios from 'axios';

export default class TermsService {
  async getTermsForImportantDates() {
    // TODO: configurable URL
    const res = await axios.get(`${API_URL}/api/terms/terms_for_important_dates.json`);

    const data = res.data.data;

    return { currentTerm: data.current_term, 
             terms:       data.terms };
  }
}
